
export const setNavContext = (key: string, data: any) => {
  try {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      window.sessionStorage.setItem(key, JSON.stringify(data));
    }
  } catch (_) { /* ignore */ }
};

export const getNavContext = (key: string): any | null => {
  try {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      const val = window.sessionStorage.getItem(key);
      return val ? JSON.parse(val) : null;
    }
  } catch (_) { /* ignore */ }
  return null;
};

export const setGlobalNavContext = (data: any) => {
  setNavContext('global_navigation', data);
  
  if (data.idCiclo) {
    setNavContext('admin_diplomado', { idDiplomado: data.idDiplomado });
    setNavContext('admin_ciclo', { idCiclo: data.idCiclo, nombreCiclo: data.nombreCiclo });
    setNavContext('facil_ciclo', { idCiclo: data.idCiclo, nombreCiclo: data.nombreCiclo });
    setNavContext('alumno_ciclo', { idCiclo: data.idCiclo, nombreCiclo: data.nombreCiclo, idDiplomado: data.idDiplomado, nombreDiplomado: data.nombreDiplomado });
  }

  if (data.idGrupo) {
    setNavContext('admin_grupo', { 
      idGrupo: data.idGrupo, 
      nombreGrupo: data.nombreGrupo,
      idCiclo: data.idCiclo 
    });
    setNavContext('facil_grupo', {
      idGrupo: data.idGrupo,
      nombreGrupo: data.nombreGrupo,
      idCiclo: data.idCiclo
    });
    setNavContext('alumno_grupo', {
      idGrupo: data.idGrupo,
      nombreGrupo: data.nombreGrupo,
      idCiclo: data.idCiclo,
    });
  }

  if (data.idGrupoSesion) {
    setNavContext('facil_grupoSesion', { 
      idGrupoSesion: data.idGrupoSesion,
      idGrupo: data.idGrupo,
      idCiclo: data.idCiclo 
    });
    setNavContext('admin_grupoSesion', { 
      idGrupoSesion: data.idGrupoSesion,
      idGrupo: data.idGrupo,
      idCiclo: data.idCiclo 
    });
    setNavContext('alumno_sesion', {
      idGrupoSesion: data.idGrupoSesion,
      idGrupo: data.idGrupo,
      idModulo: data.idModulo,
      idCiclo: data.idCiclo,
      nombreSesion: data.nombreSesion
    });
  }

  if (data.idModulo) {
    setNavContext('alumno_modulo', {
      idModulo: data.idModulo,
      nombreModulo: data.nombreModulo,
      idCiclo: data.idCiclo,
      nombreCiclo: data.nombreCiclo
    });
  }

  if (data.idEvaluacion) {
    const rol = data.rol === 'facilitador' ? 'facil' : 'alumno';
    setNavContext(`${rol}_evaluacion`, {
      idEvaluacion: data.idEvaluacion,
      nombreEvaluacion: data.nombreEvaluacion,
      idModulo: data.idModulo,
      nombreModulo: data.nombreModulo,
      idCiclo: data.idCiclo,
      nombreCiclo: data.nombreCiclo,
      esEncuesta: data.esEncuesta,
      idEvaluacionIntento: data.idEvaluacionIntento || null,
    });
  }

  if (data.idEvaluacionIntento) {
    const rol = data.rol === 'facilitador' ? 'facil' : 'alumno';
    setNavContext(`${rol}_evaluacionIntento`, {
      idEvaluacionIntento: data.idEvaluacionIntento,
      idEvaluacion: data.idEvaluacion,
      nombreEvaluacion: data.nombreEvaluacion,
      esEncuesta: data.esEncuesta,
      idModulo: data.idModulo,
      nombreModulo: data.nombreModulo,
      idCiclo: data.idCiclo,
      nombreCiclo: data.nombreCiclo,
    });
  }

  if (data.idUsuarioAlumno || data.idUsuario) {
    setNavContext('facil_alumno', {
      idUsuarioAlumno: data.idUsuarioAlumno || data.idUsuario,
      idGrupo: data.idGrupo,
      idCiclo: data.idCiclo
    });
  }

  if (data.idTareaSesion) {
    setNavContext('facil_tareaSesion', { idTareaSesion: data.idTareaSesion });
    setNavContext('admin_tareaSesion', { idTareaSesion: data.idTareaSesion });
    setNavContext('alumno_tarea', { idTareaSesion: data.idTareaSesion, idGrupoSesion: data.idGrupoSesion, idModulo: data.idModulo, idCiclo: data.idCiclo });
  }

  if (data.idTareaAlumno) {
    setNavContext('alumno_entrega', { idTareaAlumno: data.idTareaAlumno, idTareaSesion: data.idTareaSesion, idModulo: data.idModulo, idCiclo: data.idCiclo });
  }
};

export const getGlobalNavContext = (): any | null => {
  return getNavContext('global_navigation');
};

export const buildNavigationData = (currentPath: string, searchParams: URLSearchParams): any => {
  const param = searchParams.get('data');
  let payload: any = null;

  if (param) {
    try {
      const decryptModule = require('./decrypt');
      const decrypt = decryptModule.decrypt || decryptModule.default?.decrypt || decryptModule.default;
      if (decrypt && typeof decrypt === 'function') {
        payload = JSON.parse(decrypt(param));
      }
    } catch (_) {
      payload = null;
    }
  }

  if (!payload) {
    payload = getGlobalNavContext();
  }

  if (!payload) {
    if (currentPath.includes('/facilitador')) {
      payload =
        getNavContext('facil_evaluacionIntento') ||
        getNavContext('facil_evaluacion') ||
        getNavContext('facil_alumno') ||
        getNavContext('facil_grupo') ||
        getNavContext('facil_ciclo') ||
        getNavContext('facil_grupoSesion') ||
        getNavContext('facil_tareaSesion');
    } else if (currentPath.includes('/administrador')) {
      payload = getNavContext('admin_ciclo') || getNavContext('admin_grupo') || getNavContext('admin_grupoSesion');
    } else if (currentPath.includes('/alumno')) {
      payload =
        getNavContext('alumno_evaluacionIntento') ||
        getNavContext('alumno_evaluacion') ||
        getNavContext('alumno_sesion') ||
        getNavContext('alumno_modulo') ||
        getNavContext('alumno_ciclo') ||
        getNavContext('alumno_entrega');
    }
  }

  return payload;
};

export const clearNavContext = () => {
  const keys = [
    'global_navigation',
    'admin_diplomado',
    'admin_ciclo', 
    'admin_grupo',
    'admin_grupoSesion',
    'admin_tareaSesion',
    'facil_ciclo',
    'facil_grupo',
    'facil_alumno',
    'facil_grupoSesion', 
    'facil_tareaSesion',
    'alumno_ciclo',
    'alumno_modulo',
    'alumno_grupo',
    'alumno_sesion',
    'alumno_tarea',
    'alumno_entrega',
    'alumno_evaluacion',
    'alumno_evaluacionIntento',
    'facil_evaluacion',
    'facil_evaluacionIntento'
  ];
  
  keys.forEach(key => {
    try {
      if (typeof window !== 'undefined' && window.sessionStorage) {
        window.sessionStorage.removeItem(key);
      }
    } catch (_) { /* ignore */ }
  });
};
